// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"953":"087d3e6b26b43caf","1939":"8697284691759bae","2292":"00e2a6aa8ab4f36d"}[chunkId] + ".css";
};